import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { label: 'O nama', href: '#about' },
      { label: 'Proizvodi', href: '#products' },
      { label: 'Kontakt', href: '#contact' },
    ],
  };

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Instagram, href: '#', label: 'Instagram' }
  ];

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-16 lg:py-20 grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16">
          {/* Brand Column */}
          <div className="space-y-6">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_serb-landing/artifacts/fwicggqw_logo" 
                  alt="Logo"
                  className="h-10 w-10 brightness-0 invert"
                />
                <div className="flex items-baseline">
                  <span className="text-2xl font-bold">Nameštaj</span>
                  <span className="ml-2 text-2xl font-light opacity-80">Sanin</span>
                </div>
              </div>
              <p className="text-sm lg:text-base text-primary-foreground/80 leading-relaxed max-w-sm">
                Stvaramo nameštaj koji donosi toplinu, eleganciju i neponovljiv stil u vaš dom već više od 25 godina.
              </p>
            </div>

            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm text-primary-foreground/80">
                <MapPin className="w-4 h-4 flex-shrink-0" />
                <span>Prijepolje, Srbija</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-primary-foreground/80">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span>+381 64 1722224</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-primary-foreground/80">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span>elvisahmetovic2015@gmail.com</span>
              </div>
            </div>

            {/* Social Links */}
            {/* <div className="flex gap-3 pt-2">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    aria-label={social.label}
                    className="w-10 h-10 bg-primary-foreground/10 hover:bg-primary-foreground/20 rounded-lg flex items-center justify-center transition-colors duration-200"
                  >
                    <Icon className="w-5 h-5" />
                  </a>
                );
              })}
            </div> */}
          </div>

          {/* Links Column - SAMO KOMPANIJA */}
          <div>
            <h3 className="font-semibold text-primary-foreground mb-5 text-base">Kompanija</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-primary-foreground/10">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-primary-foreground/80">
            <p>
              © {currentYear} Powered by Limtech Solutions
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
